//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchInput from '@/components/search-input';
import divSpan from '@/components/DivSpan';
import accountTp from '@/components/page-temporary/accountTp'
export default {
  name: "qualificatiion-expires-query",
  components:{
    searchInput,
    divSpan,
    accountTp,
  },
  data(){
    return{
      show:true,
      config:{
        url:'api/supplier/page',
        title:'供应商账号管理',
        workflowSearchBean:{},
        property: "id",
        fixRules:{},
        inputCondition:{
          placeholder:'供应商编号/名称',
          searchCondition:'key',
          rules:[{field: "supplierCode-supplierName", option: "LIKE_ANYWHERE"}]
        },
      },
      configTodo:{
        url:'api/sup-account/page',
        title:'我的账号',
        workflowSearchBean:{},
        property: "id",
        fixRules:{},
      },
      wrapperHeight:0,
      allLoaded:false,
      list:[],
      userType:1
    }
  },
  methods:{
    goDetail(data){
      this.$router.push(`/supplier-account-detail/${data.supplierName}`);
    },
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },

    //跳转到详情页
    goProductDetail(id){
      this.$router.push(`new-product-view/${id}/simaple/1`)
    }
  },
  mounted(){
    this.userType = this.$route.query.userType || 1;
    setTimeout(() => {
      this.init();
      this.$refs.header.getlist();
    },200);
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier-account/supplier-account-query.vue